import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Field } from "redux-form/immutable";
import { Grid, MenuItem } from "@material-ui/core";

import {
  FACILITY_STATUS,
  EDIT_FIXED_FACILITY_FORM,
} from "features/planner/planner.constants";

import TextField from "app/components/form/TextField";
import { getFieldsFromState } from "features/planner/planner.selectors";
import { facilityStatusToString } from "features/planner/planner.mappers";
import ReadOnlyWarning from "features/planner/settings/components/ReadOnlyWarning";

const renderTextField = props => (
  <Field fullWidth margin="normal" component={TextField} {...props} />
);

const FixedFacilityForm = ({ handleSubmit, fields, sourceUri }) => {
  if (sourceUri) {
    return (
      <ReadOnlyWarning>
        This facility is read-only and cannot be edited
      </ReadOnlyWarning>
    );
  }

  return (
    <form onSubmit={handleSubmit} id={EDIT_FIXED_FACILITY_FORM.ID}>
      <Grid container>
        <Grid item xs={12}>
          {renderTextField({
            label: "Name",
            required: true,
            autoFocus: true,
            name: EDIT_FIXED_FACILITY_FORM.NAME,
          })}
        </Grid>
        <Grid item xs={12}>
          {renderTextField({
            label: "Operator",
            name: EDIT_FIXED_FACILITY_FORM.OPERATOR,
          })}
        </Grid>
        <Grid item xs={12}>
          {renderTextField({
            select: true,
            label: "Status",
            name: EDIT_FIXED_FACILITY_FORM.STATUS,
            children: Object.values(FACILITY_STATUS).map(facilityStatus => (
              <MenuItem key={facilityStatus} value={facilityStatus}>
                {facilityStatusToString(facilityStatus)}
              </MenuItem>
            )),
          })}
        </Grid>
        <Grid item xs={12}>
          {renderTextField({
            select: true,
            required: true,
            label: "Field",
            name: EDIT_FIXED_FACILITY_FORM.FIELD,
            children: fields.map(field => (
              <MenuItem key={field.get("id")} value={field.get("id")}>
                {field.get("name")}
              </MenuItem>
            )),
          })}
        </Grid>
      </Grid>
    </form>
  );
};

export default compose(
  connect((state, { formValueSelector }) => ({
    fields: getFieldsFromState(state),
    sourceUri: formValueSelector(state, EDIT_FIXED_FACILITY_FORM.SOURCE_URI),
  })),
)(FixedFacilityForm);
